import { render } from "./CmsTrailerGroups.vue?vue&type=template&id=d72cc25e&scoped=true"
import script from "./CmsTrailerGroups.vue?vue&type=script&lang=js"
export * from "./CmsTrailerGroups.vue?vue&type=script&lang=js"

import "./CmsTrailerGroups.vue?vue&type=style&index=0&id=d72cc25e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d72cc25e"]])

export default __exports__